import { useMutation } from '@tanstack/react-query';
import { updateUserPreference, updateUserPreferences } from '../api/http-req';

// Mutation hooks wrapping the UNCHANGED api functions (which still perform the
// post-success user-store write). Adopting these via mutateAsync at call sites
// preserves the existing .then/.catch orchestration verbatim, while routing the
// write through the MutationCache so it's logged at the operation level (see
// query-client.ts) and exposes isPending. mutationKey is the log label.

export function useUpdateUserPreference() {
  return useMutation({
    mutationKey: ['user', 'preferences', 'update'],
    mutationFn: ({ key, value }: { key: string; value: string }) => updateUserPreference(key, value),
  });
}

export function useUpdateUserPreferences() {
  return useMutation({
    mutationKey: ['user', 'preferences', 'updateBatch'],
    mutationFn: (preferences: Array<{ key: string; value: string }>) => updateUserPreferences(preferences),
  });
}
